import { ChevronsDownUp, ChevronsUpDown, Plus } from 'lucide-react';
import { LiksButton } from '../../../components/liks/LiksButton/LiksButton';
import { LiksIconButton } from '../../../components/liks/LiksIconButton/LiksIconButton';
import { LiksRefreshButton } from '../../../components/liks/LiksRefreshButton/LiksRefreshButton';
import { LiksSearch } from '../../../components/liks/LiksSearch/LiksSearch';

type KnowledgeCrawlsToolbarProps = {
  canManageCrawls: boolean;
  crawlSearchInput: string;
  crawlsCount: number;
  areAllCrawlGroupsExpanded: boolean;
  translate: (key: string, params?: Record<string, string>) => string;
  onCrawlSearchChange: (value: string) => void;
  onStartCrawl: () => void;
  onManualRefresh: () => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
};

export function KnowledgeCrawlsToolbar({
  canManageCrawls,
  crawlSearchInput,
  crawlsCount,
  areAllCrawlGroupsExpanded,
  translate,
  onCrawlSearchChange,
  onStartCrawl,
  onManualRefresh,
  onExpandAll,
  onCollapseAll,
}: KnowledgeCrawlsToolbarProps) {
  return (
    <div className="knowledge-database__crawls-toolbar">
      <LiksSearch
        className="knowledge-database__crawls-toolbar__search"
        variant="on-light"
        value={crawlSearchInput}
        onChange={onCrawlSearchChange}
        placeholder={translate('knowledge.searchCrawlsPlaceholder')}
        clearLabel={translate('common.search.clear')}
        aria-label={translate('knowledge.searchCrawlsLabel')}
      />
      {canManageCrawls ? (
        <LiksButton
          type="button"
          className="knowledge-database__crawls-toolbar__start"
          onClick={onStartCrawl}
        >
          <Plus strokeWidth={2} aria-hidden />
          {translate('knowledge.startNewCrawl')}
        </LiksButton>
      ) : null}
      <div className="knowledge-database__crawls-toolbar__actions">
        <LiksRefreshButton
          className="knowledge-database__refresh-button"
          onRefresh={onManualRefresh}
        />
        <LiksIconButton
          className="knowledge-database__crawls-toolbar__expand-toggle"
          variant="outlined"
          disabled={crawlsCount === 0}
          onClick={areAllCrawlGroupsExpanded ? onCollapseAll : onExpandAll}
          aria-label={
            areAllCrawlGroupsExpanded
              ? translate('knowledge.crawlsCollapseAll')
              : translate('knowledge.crawlsExpandAll')
          }
          title={
            areAllCrawlGroupsExpanded
              ? translate('knowledge.crawlsCollapseAll')
              : translate('knowledge.crawlsExpandAll')
          }
        >
          {areAllCrawlGroupsExpanded ? (
            <ChevronsDownUp strokeWidth={2} aria-hidden />
          ) : (
            <ChevronsUpDown strokeWidth={2} aria-hidden />
          )}
        </LiksIconButton>
      </div>
    </div>
  );
}
